/** Rutare (react-router). Public: auth + pagina publică de clip. Restul sub sesiune. */
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { RequireAuth } from './context/SessionContext';
import { RealtimeProvider } from './context/RealtimeContext';
import { AppShell } from './components/AppShell';
import { LoginPage } from './routes/LoginPage';
import { OnboardingPage } from './routes/OnboardingPage';
import { PublicClipPage } from './routes/PublicClipPage';
import { DashboardPage } from './routes/DashboardPage';
import { CreateClipPage } from './routes/CreateClipPage';
import { WizardPage } from './routes/WizardPage';
import { InterviewPage } from './routes/InterviewPage';
import { ClipPage } from './routes/ClipPage';
import { CampaignsPage } from './routes/CampaignsPage';
import { LivrariPage } from './routes/LivrariPage';
import { GaleriePage } from './routes/GaleriePage';
import { ProdusePage } from './routes/ProdusePage';
import { UltraPage } from './routes/UltraPage';
import { UltraJobPage } from './routes/UltraJobPage';
import { CumparaPage } from './routes/CumparaPage';
import { SuportPage } from './routes/SuportPage';
import { SetariPage } from './routes/SetariPage';
import { NotificariPage } from './routes/NotificariPage';
import { NotFoundPage } from './routes/NotFoundPage';

function Protected() {
  return (
    <RequireAuth>
      <RealtimeProvider enabled>
        <Outlet />
      </RealtimeProvider>
    </RequireAuth>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/clip/:token" element={<PublicClipPage />} />
      <Route path="/public/clips/:token" element={<PublicClipPage />} />

      <Route element={<Protected />}>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/wizard" element={<WizardPage />} />
        <Route path="/interviu" element={<InterviewPage />} />
        <Route path="/interviu/:id" element={<InterviewPage />} />
        <Route element={<AppShell />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/creeaza" element={<CreateClipPage />} />
          <Route path="/clipuri/:id" element={<ClipPage />} />
          <Route path="/campanii" element={<CampaignsPage />} />
          <Route path="/livrari" element={<LivrariPage />} />
          <Route path="/galerie" element={<GaleriePage />} />
          <Route path="/produse" element={<ProdusePage />} />
          <Route path="/ultra" element={<UltraPage />} />
          <Route path="/ultra/:jobId" element={<UltraJobPage />} />
          <Route path="/cumpara" element={<CumparaPage />} />
          <Route path="/suport" element={<SuportPage />} />
          <Route path="/suport/:id" element={<SuportPage />} />
          <Route path="/setari" element={<SetariPage />} />
          <Route path="/notificari" element={<NotificariPage />} />
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
